import React from "react";
import { Link } from "react-router-dom";
import { MdDangerous } from "react-icons/md";
import { TiWarningOutline } from "react-icons/ti";
import { GoInfo } from "react-icons/go";
import usePortal from "../../contexts/PortalContext";
import { PortalBannerType } from "../../__generated__/api";
import Styles from "./Banner.module.scss";

const FEATURE_DISPLAY_BANNER = "frontend.trial.banner";

const STYLES = {
    [PortalBannerType.Danger]: {
        icon: <MdDangerous />,
        className: "bg-danger text-white",
    },
    [PortalBannerType.Warning]: {
        icon: <TiWarningOutline />,
        className: "bg-danger-light text-white",
    },
    [PortalBannerType.Info]: {
        icon: <GoInfo />,
        className: "bg-blue-dark text-white",
    },
};

export default function Banner() {
    const { banner, featureFlags } = usePortal();

    const showBanner = featureFlags.has(FEATURE_DISPLAY_BANNER)
    && banner?.expirationDate
    && banner?.expirationDate.getTime() > Date.now();

    if (!banner || !showBanner) {
        return null;
    }

    banner.type = PortalBannerType.Info as PortalBannerType;

    const style = STYLES[banner.type];
    return (
        <Link
            className={`top-0 w-100 d-block text-center p-2 text-decoration-none ${style.className} ${
                Styles["banner-container"]}`}
            to={banner.linkUrl as string}
        >
            {style.icon}

            {" "}
            {banner.message}
        </Link>
    );
}
